import { useTranslation } from 'react-i18next';
import { Button } from '../../../../common/components/ui/button';
import { CartDialogDeliveryCalendar } from './CartDialogDeliveryCalendar';
import { abortUserInputForCart } from '../../actions/cartActions';

function handleAbort() {
  abortUserInputForCart();
}

export function CartDialogCreation() {
  const { t } = useTranslation();

  return (
    <CartDialogDeliveryCalendar
      title={t('Neuer Auftrag erstellen')}
      description={t('Wählen Sie das Wunschlieferdatum')}
    >
      <Button
        variant={'primaryOutline'}
        className={'w-full desktop:w-fit'}
        onClick={handleAbort}
        data-testid={'cart-new-cancel-button'}
      >
        {t('Abbrechen')}
      </Button>
    </CartDialogDeliveryCalendar>
  );
}
